<template>
  <section :class="$style.background">
    <GiantTitle data-title
      :class="$style.bigTitle"
      :title="getCurrentData.title"
      :style="{
        transform: `translateY(${((delta2))}%)`,
        opacity,
      }"
      @click.native="scrollTo"
    />
    <div
      :class="$style.heroDiscover"
      :style="{
        transform: `translate3d(-50%, ${1920 * (delta)}%, 0)`,
        opacity: delta > 0 ? 0 : 1
      }"
      v-if="enableSlider"
      data-scroll
    >
      <p>scroll to</p>
      <span>
        <span></span>
      </span>
      <p>discover</p>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import EventBus from '@/scripts/event-bus'
import { getDevice } from '@/scripts/utils'
import GiantTitle from '@/components/GiantTitle'

export default {
  components: {
    GiantTitle
  },

  computed: {
    ...mapGetters(['getCurrentData', 'getScrollbar']),
    ...mapState(['enableSlider']),

    delta() {
      let res = 0

      const min = getDevice() === 'xs' ? 0.64 : getDevice() === 'sm' ? 0.71 : 0.8 // eslint-disable-line

      if (this.getScrollbar) {
        const scrollTop = this.getScrollbar.scrollTop
        res = Math.min((scrollTop / window.innerHeight), min)
      }

      return res
    },

    delta2() {
      let res = 0

      const min = getDevice() === 'xs' ? 1.4 : getDevice() === 'sm' ? 1.4 : 1.5 // eslint-disable-line
      const multi = getDevice() === 'xs' ? 40 : getDevice() === 'sm' ? 45 : 70 // eslint-disable-line

      if (this.getScrollbar) {
        const scrollTop = this.getScrollbar.scrollTop
        res = Math.min((scrollTop / window.innerHeight), min)
      }
      const calc = multi * res;

      return calc
    },

    opacity() {
      let op = 1

      if (this.getScrollbar) {
        const scrollTop = this.getScrollbar.scrollTop
        op = scrollTop > window.innerHeight ? 1 - Math.min((scrollTop - window.innerHeight) / (window.innerHeight / 3), 1) : 1;
      }

      return op;
    }
  },

  methods: {
    scrollTo() {
      EventBus.$emit('scrollTo', window.innerHeight, 2000)
    }
  }
}
</script>

<style module lang="scss">
@import "~sass-mq/mq";
@import "../styles/colors";

@keyframes move {
  0% {
    transform: scaleY(0);
    transform-origin: 0% 0%;
    opacity: 0;
  }
  50% {
    transform: scaleY(1);
    transform-origin: 0% 0%;
    opacity: 1;
  }
  51% {
    transform: scaleY(1);
    transform-origin: 0% 100%;
    opacity: 1;
  }
  100% {
    transform: scaleY(0);
    transform-origin: 0% 100%;
    opacity: 0.5;
  }
}

.background {
  position: relative;
  width: 100%;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.bigTitle {
  position: relative;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
  line-height: 100vh;
  line-height: calc(var(--vh, 1vh) * 100);
  margin: 0;
  white-space: nowrap;

  pointer-events: auto;
  cursor: pointer;
}

.hero {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-position: center bottom;
  background-size: 110% auto;
  background-repeat: no-repeat;

  @include mq(sm) {
    background-size: auto 90%;
  }
}

.heroDiscover {
  position: absolute;
  left: 50%;
  bottom: 0;

  color: $color-ui;

  display: flex;
  align-items: center;
  justify-content: flex-start;

  transition: opacity 0.4s ease-in-out;

  > span {
    position: relative;
    width: 2px;
    height: 60px;
    margin: 0 20px;
    background-color: $color-ui;

    > span {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

      background-color: $color-blue;
      transform: scaleY(0);

      animation: move 1.8s infinite cubic-bezier(.17,.67,.59,.85);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Hero.vue